import React,{useState,useEffect} from "react";
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import AsyncSelect from 'react-select/async';
import {
    getCustomers,
} from "store/actions"

const UserSelector = ({
    users,
    totalUsers,
    onGetUsers,
    loading,
    onChangeHandler,
    defaultSelected = [],
    role,
    user,
    isMulti=false,
    placeholder="Select...",
    ...props}) =>{
     
    const [filter, setFilter] = useState({
        orderBy: "date_created_utc",
        order: -1,
        page: 0,
        limit: 30,
        search: "",
        ownerId : role==="VENDOR" ? user?._id : undefined
      })
      const [selected,setSelected] = useState(defaultSelected);

    useEffect(()=>{
        setSelected(defaultSelected)
    },[defaultSelected])

    const collectionOptions = (users) => ((users || []).map((item)=> ({value : item?._id,label : item?.email})));  
    
    const defaultOptions = (users || []).map((item)=> ({value : item?._id,label : item?.email}));  

    useEffect(() => {
        onGetUsers({ ...filter });
      }, [JSON.stringify(filter)]);
    


  const loadOptions = (inputValue,callback) =>{
      onGetUsers({ ...filter, search: inputValue }, ({ data }) => {
        console.log("response",data)
        const options = collectionOptions(data);
        setTimeout(()=>{
            callback(options);  
        },1000);
        setFilter({...filter,search:inputValue})
    });
}

  const onChangeSelector = (data) =>{
    if(isMulti){
    if(data?.length){
        // const ids= [];
        // data.forEach((a)=>{
        //     ids.push(a.value);
        // },[])
        // console.log("allIds",ids);
        onChangeHandler && onChangeHandler(data);
        setSelected(data);
    }else{
        onChangeHandler && onChangeHandler([]);
        setSelected([]);
    }
  }else{
    onChangeHandler(data);
  }
}

    return(
           // <Select options={userOptions} />
           <AsyncSelect 
                isMulti={isMulti} 
                placeholder={placeholder}
                value={selected}
                cacheOptions
                defaultOptions={defaultOptions}  
                loadOptions={loadOptions} 
                onChange={(data)=>onChangeSelector(data)}
                // onInputChange={(value)=>onInputChange(value)}

          />
    );
}

  
const mapStateToProps = ({ customers }) => ({
    loading: customers.loading,
    users: customers.customers,
    totalUsers: customers.totalCustomers,
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onGetUsers: (data,callback) => {
        console.log(data);
        dispatch(getCustomers(data,callback));
      },
    };
  };

  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserSelector)),
  )



